import styled from 'styled-components';
import { boxShadows } from 'styles';

type MenuProps = {
  $isActive: boolean;
};

export const MenuContainer = styled.div`
  position: relative;
`;

export const MenuButton = styled.div`
  background: none;
  padding: 0;
  border: none;
  margin: 0 auto 0 0;
`;

export const Menu = styled.nav<MenuProps>`
  background: #ffffff;
  border-radius: 16px;
  position: absolute;
  top: calc(100% + 8px); // 8px gap from button
  right: 0;
  width: max-content;
  max-width: 250px;
  min-width: 64px;
  text-align: left;
  overflow: hidden;
  box-shadow: ${boxShadows.md};
  opacity: ${({ $isActive }) => ($isActive ? '1' : '0')};
  visibility: ${({ $isActive }) => ($isActive ? 'visible' : 'hidden')};
  transform: ${({ $isActive }) =>
    $isActive ? 'translateY(0)' : 'translateY(-20px)'};
  transition:
    opacity 0.4s ease,
    transform 0.4s ease,
    visibility 0.4s;

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }
`;

export const MenuItemInner = styled.div`
  padding: 16px;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.grey1};
  }
`;
